import { isDevelop } from '@/constants/configs'

export function devWarn(...args: unknown[]): void {
  if (isDevelop) console.warn(...args)
}
